var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOjo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C7AE5",
    d: "M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3zm0 16c2.04 0 4.018-.693 5.613-1.965 1.594-1.271 2.71-3.047 3.164-5.035-.456-1.987-1.572-3.76-3.166-5.03C16.016 5.7 14.038 5.009 12 5.009S7.984 5.7 6.39 6.97C4.794 8.24 3.678 10.013 3.222 12c.454 1.988 1.57 3.764 3.164 5.035C7.982 18.307 9.961 19 12 19zm0-2.5c-1.193 0-2.338-.474-3.182-1.318C7.974 14.338 7.5 13.193 7.5 12c0-1.194.474-2.338 1.318-3.182C9.662 7.974 10.807 7.5 12 7.5c1.194 0 2.338.474 3.182 1.318.844.844 1.318 1.989 1.318 3.182 0 1.194-.474 2.338-1.318 3.182-.844.844-1.989 1.318-3.182 1.318zm0-2c.663 0 1.299-.263 1.768-.732.469-.47.732-1.105.732-1.768s-.263-1.299-.732-1.768C13.299 9.763 12.663 9.5 12 9.5s-1.299.263-1.768.732c-.469.47-.732 1.105-.732 1.768s.263 1.299.732 1.768c.47.469 1.105.732 1.768.732z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOjo);
export default __webpack_public_path__ + "static/media/Icon_ojo.c22b3b3f.svg";
export { ForwardRef as ReactComponent };